import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV } from "../../data/content";

const Wordmark = () => (
    <Link to="/" data-testid="header-logo" className="flex items-center gap-3 group">
        <img
            src="/assets/thg-shield-sm.png"
            alt="Titan Haven Group LLC shield"
            className="h-8 md:h-9 w-auto"
        />
        <span className="font-display text-base md:text-lg font-semibold tracking-wide text-white">
            TITAN HAVEN GROUP <span className="text-thg-secondary text-[0.7em] tracking-[0.2em]">LLC</span>
        </span>
    </Link>
);

export const Header = () => {
    const [open, setOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        setOpen(false);
    }, [location.pathname]);

    return (
        <header className="sticky top-0 z-50 border-b border-thg-border bg-[#0a0a0a]/80 backdrop-blur-xl">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 md:h-20 flex items-center justify-between">
                <Wordmark />
                <nav className="hidden lg:flex items-center gap-8" aria-label="Primary">
                    {NAV.map((item) => (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            data-testid={item.testId}
                            className={({ isActive }) =>
                                `text-xs tracking-[0.15em] uppercase font-medium transition-colors duration-300 ${
                                    isActive ? "text-white" : "text-thg-secondary hover:text-white"
                                }`
                            }
                        >
                            {item.label}
                        </NavLink>
                    ))}
                </nav>
                <button
                    type="button"
                    data-testid="mobile-menu-toggle"
                    onClick={() => setOpen((v) => !v)}
                    aria-expanded={open}
                    aria-label={open ? "Close menu" : "Open menu"}
                    className="lg:hidden text-white p-2 -mr-2"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </div>
            {open && (
                <nav
                    className="lg:hidden border-t border-thg-border bg-[#0a0a0a] px-4 sm:px-6 py-6 flex flex-col gap-5"
                    aria-label="Mobile"
                    data-testid="mobile-menu"
                >
                    {NAV.map((item) => (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            data-testid={`${item.testId}-mobile`}
                            className={({ isActive }) =>
                                `text-sm tracking-[0.15em] uppercase font-medium transition-colors duration-300 ${
                                    isActive ? "text-white" : "text-thg-secondary hover:text-white"
                                }`
                            }
                        >
                            {item.label}
                        </NavLink>
                    ))}
                </nav>
            )}
        </header>
    );
};
